import { createSelector } from 'reselect';

const selectHelpState = (state: DefaultRootState) => state?.help;

export const selectHelpCategories = createSelector(
  [selectHelpState],
  (help) => help.categories || []
);

export const selectHelpArticle = createSelector(
  [selectHelpState, (_, slug) => slug],
  (help, slug) => help.articles?.[slug] || {}
)

export const selectHelpArticleDrawer = createSelector(
  [selectHelpState],
  (help) => help.articleDrawer || {}
);

export const selectFeaturedArticles = createSelector(
  [selectHelpState],
  (help) => help.featuredArticles || []
);

export const selectFeaturedQuestions = createSelector(
  [selectHelpState],
  (help) => help.featuredQuestions || []
);

export const selectArticlesByCategory = createSelector(
  [selectHelpState, (_, slug) => slug],
  (help, slug) => help.articlesByCategory?.[slug] || []
);

export const selectQuestionsByCategory = createSelector(
  [selectHelpState, (_, slug) => slug],
  (help, slug) => help.questionsByCategory?.[slug] || []
);

// Tag-based selectors (key can be single tag or multi-tag joined key)
export const selectArticlesByTagKey = createSelector(
  [selectHelpState, (_, key) => key],
  (help, key) => help.articlesByTag?.[key] || []
);

export const selectQuestionsByTagKey = createSelector(
  [selectHelpState, (_, key) => key],
  (help, key) => help.questionsByTag?.[key] || []
);

// Internal tag-based selectors
export const selectArticlesByInternalTagKey = createSelector(
  [selectHelpState, (_, key) => key],
  (help, key) => help.articlesByInternalTag?.[key] || []
);

export const selectQuestionsByInternalTagKey = createSelector(
  [selectHelpState, (_, key) => key],
  (help, key) => help.questionsByInternalTag?.[key] || []
);

export const selectCurrentArticleCategory = createSelector(
  [selectHelpState],
  (help) => help.currentArticleCategory || null
);

export const selectCurrentArticleSlug = createSelector(
  [selectHelpState],
  (help) => help.currentArticleSlug || null
);

export const selectCurrentCategorySlug = createSelector(
  [selectHelpState],
  (help) => help.currentCategorySlug || null
);

export const selectCurrentTagKey = createSelector(
  [selectHelpState],
  (help) => help.currentTagKey || null
);

export const selectCurrentInternalTagKey = createSelector(
  [selectHelpState],
  (help) => help.currentInternalTagKey || null
);

export const selectAllQuestions = createSelector(
  [selectHelpState],
  (help) => help.allQuestions || []
);

export const selectHelpLocale = createSelector(
  [selectHelpState],
  (help) => help.locale || null
);
